import { Injectable, Inject, HttpStatus, forwardRef } from '@nestjs/common';
import {  Raw, getConnection, Repository, Like } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm'; 
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { ProfileEntity } from './profile.entity';
import { getMyNetworkResponseModel, GetProfilePicResponseModel, GetProfileResponseModel } from './dto/profile-response-model';
import { ProfileDTO } from './dto/profile.dto';
import { UserEntity } from '../user/user.entity';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import * as fs from 'fs';
import { WelfareService } from '../welfare/welfare.service';

@Injectable()
export class ProfileService {
    constructor(
        @InjectRepository(ProfileEntity)
        private profileRepo: Repository<ProfileEntity>, 
        @InjectRepository(UserEntity)
        private userRepo: Repository<UserEntity>,
        @Inject(forwardRef(()=>WelfareService))
        private welfareService: WelfareService, 
    ) {}

    async createProfile(profileData) {
        try {
            const profile = await this.profileRepo.save(profileData);
            if(profile) {
                return profile;
            } else { 
                return null;                
            }        
        } catch (error) {
            throw error;
        }
    }

    async updateProfile(queryParams, profileDto: ProfileDTO, request:Request): Promise<GetProfileResponseModel> {
        const response = new GetProfileResponseModel();
        try {
            const checkProfileExe = await this.profileRepo.findOne({where:{userId:profileDto.userId}});
            if(profileDto.villageId > 0) {
                profileDto.villageId = profileDto.villageId
              } else {
                profileDto.villageId = null;
              }
            if(queryParams.apiVersion == 1) {
                if(checkProfileExe) {
                    const updatedUser = await this.profileRepo.update(checkProfileExe.Id, profileDto);
                    if(updatedUser && profileDto.mobileNo != null) {
                        await this.userRepo.update({Id:profileDto.userId},{mobileNo:profileDto.mobileNo})
                    }
                    if(updatedUser && profileDto.email != null) {
                        await this.userRepo.update({Id:profileDto.userId},{email:profileDto.email})
                    }
                    const updatedData = await this.profileRepo.findOne({
                        where:{Id:checkProfileExe.Id}
                    });
                    if(updatedUser) {
                        response.status = true;
                        response.data   = updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Profile updated successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Profile update failed')
                    }
                } else {
                    const saveUser = await this.profileRepo.save(profileDto);
                    if(saveUser && profileDto.mobileNo != null) {
                        await this.userRepo.update({Id:profileDto.userId},{mobileNo:profileDto.mobileNo})
                    }
                    if(saveUser && profileDto.email != null) {
                        await this.userRepo.update({Id:profileDto.userId},{email:profileDto.email})
                    }
                    if(saveUser) {
                        response.status = true;
                        response.data   = saveUser;
                        response.statusCode = 50000;
                        response.internalMessage = 'Profile created successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Profile creation failed')
                    }
                }
            } else {
                if(checkProfileExe) {
                    const updatedUser = await this.profileRepo.update(checkProfileExe.Id, profileDto);
                    if(updatedUser && profileDto.mobileNo != null) {
                        await this.userRepo.update({Id:profileDto.userId},{mobileNo:profileDto.mobileNo})
                    }
                    if(updatedUser && profileDto.email != null) {
                        await this.userRepo.update({Id:profileDto.userId},{email:profileDto.email})
                    }
                    const updatedData = await this.profileRepo.findOne({
                        where:{Id:checkProfileExe.Id}
                    });
                    if(updatedUser) {
                        response.status = true;
                        response.data   = updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = 'Profile updated successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Profile update failed')
                    }
                } else {
                    const saveUser = await this.profileRepo.save(profileDto);
                    if(saveUser && profileDto.mobileNo != null) {
                        await this.userRepo.update({Id:profileDto.userId},{mobileNo:profileDto.mobileNo})
                    }
                    if(saveUser && profileDto.email != null) {
                        await this.userRepo.update({Id:profileDto.userId},{email:profileDto.email})
                    }
                    if(saveUser) {
                        response.status = true;
                        response.data   = saveUser;
                        response.statusCode = 50000;
                        response.internalMessage = 'Profile created successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse(99998, 'Profile creation failed')
                    }
                }
            }
            return response;
        } catch (error) {
            return errorHandler(GetProfileResponseModel, error);
        }
    }

    async updateProfilePic(queryParams, filesData, userId ): Promise<GetProfilePicResponseModel> {
        const response = new GetProfilePicResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const oldData = await this.profileRepo.findOne({
                    where:{userId:userId}
                });                
                if(oldData.profilePic != null) {
                    var pary = oldData.profilePic.split('/');
                    var fname = pary[2];
                    fs.unlinkSync('./public/profilePic/'+fname);
                }  
                const fileUpload = await this.profileRepo.update({userId:userId},filesData[0]);
                const updatedData = await this.profileRepo.findOne({
                   where:{userId:userId}
                });
                if(fileUpload) {
                    const da = {
                        userId:updatedData.userId,
                        profilePic: updatedData.profilePic != null ? `${process.env.WORKINGURL}/${updatedData.profilePic}` : '',						
                    }; 
                    response.status = true;
                    response.data   = da;
                    response.statusCode = 50000;
                    response.internalMessage = 'profile picture upload successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'profile picture not updated')
                }
            } else {
                const oldData = await this.profileRepo.findOne({
                    where:{userId:userId}
                });                
                if(oldData.profilePic != null) {
                    var pary = oldData.profilePic.split('/');
                    var fname = pary[2];
                    fs.unlinkSync('./public/profilePic/'+fname);
                }  
                const fileUpload = await this.profileRepo.update({userId:userId},filesData[0]);
                const updatedData = await this.profileRepo.findOne({
                   where:{userId:userId}
                });
                if(fileUpload) {
                    const da = {
                        userId:updatedData.userId,
                        profilePic: updatedData.profilePic != null ? `${process.env.WORKINGURL}/${updatedData.profilePic}` : '',						
                    }; 
                    response.status = true;
                    response.data   = da;
                    response.statusCode = 50000;
                    response.internalMessage = 'profile picture upload successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'profile picture not updated')
                }
            }      
            return response;
        } catch (error) {
            return errorHandler(GetProfilePicResponseModel, error);
        }
    }

    async getProfileByUserId(queryParams, userId, request:Request):Promise<getMyNetworkResponseModel> {
        const response = new getMyNetworkResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const profile = await this.profileRepo.findOne({
                    where:{userId:userId}
                });
                if(profile) {
                    if(profile.profilePic != null) {
                        profile.profilePic = `${process.env.WORKINGURL}/${profile.profilePic}`;
                    }
                    const welfare = await this.welfareService.getAllActiveWelfareByUID(userId);
                    response.status = true;
                    response.data   = profile;
                    response.welfare=welfare;
                    response.statusCode = 50000;
                    response.internalMessage = 'get profile info successfully';
                    response.intlCode = 11108;
                } else { 
                    throw new ErrorResponse(99998, 'profile info not found')
                }
            } else {
                const profile = await this.profileRepo.findOne({
                    where:{userId:userId}
                });
                if(profile) {
                    if(profile.profilePic != null) {
                        profile.profilePic = `${process.env.WORKINGURL}/${profile.profilePic}`;
                    }
                    const welfare = await this.welfareService.getAllActiveWelfareByUID(userId);
                    response.status = true;
                    response.data   = profile;
                    response.welfare=welfare;
                    response.statusCode = 50000;
                    response.internalMessage = 'get profile info successfully';
                    response.intlCode = 11108;
                } else { 
                    throw new ErrorResponse(99998, 'profile info not found')
                }
            }
            return response;           
        } catch (error) {
            return errorHandler(getMyNetworkResponseModel, error);
        }
    }

    async getUserByUId(userId) {
        const profile = await this.profileRepo.findOne({
            relations:['user','user.roles'],
            where:{userId:userId}
        });
        if(profile) { 
            return profile;
        } else {
            return null;
        }
    }

    async getProfileByEmail(email) {
        const profile = await this.profileRepo.findOne({
            relations:['user','user.roles'],
            where:{email:email}
        });
        if(profile) { 
            return profile;
        } else {
            return null;
        }
    }

    async getProfileByPhone(mobileNo) {
        const profile = await this.profileRepo.findOne({
            relations:['user','user.roles'],
            where:{mobileNo:mobileNo}
        });
        if(profile) { 
            return profile;
        } else {
            return null;
        }
    }

    async getSearchUser(search) {
        const data =await this.profileRepo.find({               
            where: [{mobileNo: Like(`%${search}%`),status: true},
                    {firstName:Like(`%${search}%`),status: true},
                    {email:Like(`%${search}%`),status: true}],
            order: { createdAt: 'DESC' }
        });
        if(data.length > 0) {
            return data;
        }else {
            return null;
        }          
    }
}







